<template>
  <div class="headBar flex_g vertical between">
    <div class="logoView flex_g vertical" @click="goHome(pageUrl)">
      <img src="@/assets/images/starryGLLogo.png" alt="" />
    </div>
    <div class="menuView flex_g vertical">
      <div
        class="menuItem"
        v-for="(item, index) of menuList"
        :key="index"
        @click.stop="changePage(item)"
      >
        <p
          class="menuName"
          :style="pageUrl == item.menuUrl ? 'color:#0548b8' : ''"
        >
          {{ $t(item.menuName) }}
        </p>
        <p class="menuLine" v-if="pageUrl == item.menuUrl"></p>
        <div
          class="menuChildView"
          v-if="item.menuChild && item.menuChild.length > 0"
        >
          <div
            class="menuChildItem"
            @click.stop="changePage(s_item)"
            :class="pageUrl == s_item.menuUrl ? 'childSelect' : ''"
            v-for="(s_item, s_index) of item.menuChild"
            :key="s_index"
          >
            <div>{{ s_item.menuName }}</div>
          </div>
        </div>
      </div>
      <div class="menuLang flex_g vertical" @click="handleCommand()">
        {{ this.$i18n.locale === "zh" ? "中" : "EN" }}
      </div>
    </div>
  </div>
</template>

<script>
const MenuUrlType = {
  NO_ACTION: 0,
  PUSHES_TO_ROUTER: 1,
  OPENS_AT_NEW_WINDOW: 2,
};

export default {
  components: {},
  props: {
    pageUrl: String,
  },
  data() {
    return {
      menuList: [
        {
          menuName: "menu.about",
          menuUrl: "/starryGl/about",
          menuUrlType: MenuUrlType.PUSHES_TO_ROUTER,
          menuChild: [],
        },
        {
          menuName: "menu.getStarted",
          menuUrl: "http://115.236.33.124:7007/guide/index.html",
          menuUrlType: MenuUrlType.OPENS_AT_NEW_WINDOW,
        },
        {
          menuName: "menu.docs",
          menuUrl: "http://115.236.33.124:7007/",
          menuUrlType: MenuUrlType.OPENS_AT_NEW_WINDOW,
        },

        {
          menuName: "menu.gitHub",
          menuUrl: "http://115.236.33.124:7001/wjie98/starrygl",
          menuUrlType: MenuUrlType.OPENS_AT_NEW_WINDOW,
        },
      ],
    };
  },
  methods: {
    goHome(url) {
      if (url !== "/starryGl/home") {
        this.$router.push({
          path: "/starryGl/home",
        });
      }
    },
    changePage(item) {
      if (item.menuUrlType == MenuUrlType.PUSHES_TO_ROUTER && !!item.menuUrl) {
        this.$router.push({
          path: item.menuUrl,
        });
      } else if (
        item.menuUrlType == MenuUrlType.OPENS_AT_NEW_WINDOW &&
        !!item.menuUrl
      ) {
        window.open(item.menuUrl, "_blank");
      }
    },
    handleCommand() {
      // 点击的时候需要切换中英文的环境
      // 核心：修改 locale 配置
      this.$i18n.locale = this.$i18n.locale === "zh" ? "en" : "zh";
    },
  },
};
</script>
<style lang="scss" scoped>
.headBar {
  margin: 0 auto;
  height: 5.36rem;
  background: #ffffff;
  padding: 0 3.5rem;
  position: relative;
  z-index: 1000;

  .logoView {
    img {
      width: 10rem;
    }
  }

  .menuView {
    padding: 0 3rem 0 6rem;
    height: 100%;
    flex: 1;
    justify-content: end;

    .menuItem {
      position: relative;
      height: 100%;
      margin: 0 2rem;
      line-height: 5.36rem;
      min-width: 4rem;

      .menuName {
        font-size: 1.2rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bolder;
        color: #6782a4;
        text-align: center;
      }

      .menuLine {
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 2rem;
        transform: translate(-50%, -50%);
        height: 0.21rem;
        background: #0548b8;
        box-shadow: 0rem 0.07rem 0.29rem 0rem #9fd4f8;
        border-radius: 0.11rem;
      }

      .menuChildView {
        display: none;
        position: absolute;
        top: 5rem;
        left: -1rem;
        width: 13rem;
        background: #ffffff;
        box-shadow: 0rem 0.14rem 0.79rem -0.07rem rgba(0, 99, 206, 0.49);
        padding: 0.5rem 0;
        border-radius: 0.6rem;
        z-index: 510;

        .menuChildItem {
          padding: 1.2rem 2.3rem;

          div {
            font-size: 1rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #6782a4;
            line-height: 1.3rem;
          }
        }

        .menuChildItem:hover {
          background: #f0f6ff;

          div {
            color: #0548b8;
          }
        }
      }

      .menuChildView:after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: -0.8rem;
        left: 2rem;
        border-bottom: 0.8rem solid #fff;
        border-left: 0.6rem solid transparent;
        border-right: 0.6rem solid transparent;
        z-index: 1;
      }
    }

    .menuItem:hover {
      cursor: pointer;

      .menuName {
        color: #0548b8;
        animation: navShake 0.5s ease;
      }

      @keyframes navShake {
        0% {
          transform: translateY(0px);
        }

        50% {
          transform: translateY(-5px);
        }

        100% {
          transform: translateY(0px);
        }
      }

      .menuChildView {
        display: block;
      }
    }
  }

  .menuLang {
    width: 2.8rem;
    height: 2.8rem;
    border: 2px solid #111;
    border-radius: 4px;
    justify-content: center;
    color: #111;
    font-size: 1rem;
    font-weight: bolder;
    cursor: pointer;
  }
}

@media (min-width: 1450px) {
  .headBar {
    // width: 1440px;
    height: 53.6px;
    padding: 0 calc((100% - 1440px) / 2 + 35px);

    .logoView {
      img {
        width: 100px;
      }
    }

    .menuView {
      padding: 0 30px 0 60px;

      .menuItem {
        margin: 0 20px;
        line-height: 53.6px;
        min-width: 40px;

        .menuName {
          font-size: 14px;
        }

        .menuLine {
          width: 20px;
          height: 2px;
          box-shadow: 0px 0.63px 2.61px 0px #9fd4f8;
          border-radius: 1px;
        }
      }
    }

    .menuLang {
      width: 25px;
      height: 25px;
      border: 2px solid #111;
      border-radius: 4px;
      justify-content: center;
      color: #111;
      font-size: 9px;
      font-weight: bolder;
      cursor: pointer;
    }
  }
}
</style>
